const card = require("./card.png");
const dashboard = require("./dashboard.png");
const dashboardC = require("./dashboardC.png");
const logo = require("./logo.svg");

export default { dashboard, dashboardC, logo, card };
